/* 操作软盘组件 */
import bindAll from "lodash.bindall";
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';

import classNames from "classnames";

import styles from './key-gamepad.css';
import wordSpace from './image/word/space.png';
// import wordSpaceChecked from './image/word/space-checked.png';
// import wordSpaceDisabled from './image/word/space-disabled.png';
import word from './image/word/word.png';
import wordChecked from './image/word/word-checked.png';

import wordDisabled from './image/word/word-disabled.png';
// import otherChecked from './image/game-and-number/checked.png';
import otherDefault from './image/game-and-number/default.png';

import otherDisabled from './image/game-and-number/disabled.png';
// import mide from './image/mide.png';
import mide from './image/mide-logo.png';
import {setKeyboardType} from '../../reducers/project-state'

const isMobile = location.search.indexOf('isMobile') !== -1;

class KeyboardComponent extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, [
            'keyShow',
            'keyPress'
        ]);
        this.state = {

        };
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        this.props.setKeyboardType(nextProps.keyboard);
    }

    keyShow(code) {
        switch (code) {
            case'left arrow':
                return '←';
            case'right arrow':
                return '→';
            case'up arrow':
                return '↑';
            case'down arrow':
                return '↓';
            case'space':
                return '空格';
            default:
                return code.toUpperCase();
        }
    }

    keyPress(code) {
        switch (code) {
            case'left arrow':
                return 'ArrowLeft';
            case'right arrow':
                return 'ArrowRight';
            case'up arrow':
                return 'ArrowUp';
            case'down arrow':
                return 'ArrowDown';
            case'space':
                return ' ';
            default:
                return code.toLowerCase();
        }
    }

    render() {
        let noSupportKey = [];
        const wordList = {
            firstLine: ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
            secondLine: ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'],
            thirdLine: ['Z', 'X', 'C', 'V', 'B', 'N', 'M']
        };
        const numberList = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
        const {
            keyboard,
            keyList,
            onKeyPress,
            onKeyUp,
            userName,
        } = this.props;
        keyList.forEach(item => {
            if (item === 'down arrow') {
                noSupportKey.push('↓');
            } else if (item === 'up arrow') {
                noSupportKey.push('↑');
            } else if (item === 'left arrow') {
                noSupportKey.push('←');
            } else if (item === 'right arrow') {
                noSupportKey.push('→');
            } else if (item === 'space') {
                noSupportKey.push('空格');
            } else {
                noSupportKey.push(item);
            }
        });
        return (
            <div
                className={classNames(styles.keyGamepadContent)}
                style={{height: `${isMobile || [0, -1].indexOf(keyboard) > -1 ? 0 : 499}px`, width: `${isMobile ? '' : 480}px`, fontSize: `${isMobile ? '0.32rem' : '20px'}`}}
            >
                {/* 字母键盘 */}
                {keyboard === 10 &&
                <div className={styles.wordKeyboard} style={{paddingTop: isMobile ? (keyList.indexOf('space') > -1 ? '0.5rem' : '1rem') : (keyList.indexOf('space') > -1 ? '1rem' : '1.7rem')}}>
                    <div className={styles.line}>
                        {wordList.firstLine.map((item, i) => (
                            <div className={classNames(styles.item, {[styles.active]: keyList.indexOf(item.toLowerCase()) > -1})} key={i}
                                 // onClick={() => onKeyPress(this.keyPress(item))}
                                //pc
                                 onMouseDown={() => onKeyPress(this.keyPress(item))}
                                 onMouseUp={() => onKeyUp(this.keyPress(item))}
                                 onMouseOut={() => onKeyUp(this.keyPress(item))}
                                //mobile
                                 onTouchStart={(e) => {e.preventDefault(); onKeyPress(this.keyPress(item))}}
                                 onTouchEnd={() => onKeyUp(this.keyPress(item))}
                            >
                                <img src={keyList.indexOf(item.toLowerCase()) > -1 ? word : wordDisabled} alt=""/>
                                <div>{item}</div>
                            </div>
                        ))}
                    </div>
                    <div className={classNames(styles.line, styles.line2)}>
                        {wordList.secondLine.map((item, i) => (
                            <div className={classNames(styles.item, {[styles.active]: keyList.indexOf(item.toLowerCase()) > -1})} key={i}
                                 // onClick={() => onKeyPress(this.keyPress(item))}
                                //pc
                                 onMouseDown={() => onKeyPress(this.keyPress(item))}
                                 onMouseUp={() => onKeyUp(this.keyPress(item))}
                                 onMouseOut={() => onKeyUp(this.keyPress(item))}
                                //mobile
                                 onTouchStart={(e) => {e.preventDefault();onKeyPress(this.keyPress(item))}}
                                 onTouchEnd={() => onKeyUp(this.keyPress(item))}
                            >
                                <img src={keyList.indexOf(item.toLowerCase()) > -1 ? word : wordDisabled} alt=""/>
                                <div>{item}</div>
                            </div>
                        ))}
                    </div>
                    <div className={classNames(styles.line, styles.line3)}>
                        {wordList.thirdLine.map((item, i) => (
                            <div className={classNames(styles.item, {[styles.active]: keyList.indexOf(item.toLowerCase()) > -1})} key={i}
                                // onClick={() => onKeyPress(this.keyPress(item))}
                                //pc
                                 onMouseDown={() => onKeyPress(this.keyPress(item))}
                                 onMouseUp={() => onKeyUp(this.keyPress(item))}
                                 onMouseOut={() => onKeyUp(this.keyPress(item))}
                                //mobile
                                 onTouchStart={(e) => {e.preventDefault();onKeyPress(this.keyPress(item))}}
                                 onTouchEnd={() => onKeyUp(this.keyPress(item))}
                            >
                                <img src={keyList.indexOf(item.toLowerCase()) > -1 ? word : wordDisabled} alt=""/>
                                <div>{item}</div>
                            </div>
                        ))}
                    </div>
                    {keyList.indexOf('space') > -1 ?
                        <div className={classNames(styles.line4)}>
                            <div className={classNames(styles.spaceItem, styles.active)}
                                 // onClick={() => onKeyPress(' ')}
                                //pc
                                 onMouseDown={() => onKeyPress(' ')}
                                 onMouseUp={() => onKeyUp(' ')}
                                 onMouseOut={() => onKeyUp(' ')}
                                //mobile
                                 onTouchStart={(e) => {e.preventDefault();onKeyPress(' ')}}
                                 onTouchEnd={() => onKeyUp(' ')}
                            >
                                <img src={wordSpace} alt=""/>
                                <div>{'空格'}</div>
                            </div>
                        </div> : null
                    }
                </div>
                }
                {/* 游戏键盘 */}
                {[27, 28].indexOf(keyboard) > -1 &&
                <div className={classNames(styles.gameKeyboardIsFour, {[styles.paddingTopWeb]: !isMobile})}>
                    <div className={classNames(styles.item, styles.active)}
                         // onClick={() => onKeyPress(keyboard === 27 ? 'ArrowUp' : 'w')}
                        //pc
                         onMouseDown={() => onKeyPress(keyboard === 27 ? 'ArrowUp' : 'w')}
                         onMouseUp={() => onKeyUp(keyboard === 27 ? 'ArrowUp' : 'w')}
                         onMouseOut={() => onKeyUp(keyboard === 27 ? 'ArrowUp' : 'w')}
                        //mobile
                         onTouchStart={(e) => {e.preventDefault();onKeyPress(keyboard === 27 ? 'ArrowUp' : 'w')}}
                         onTouchEnd={() => onKeyUp(keyboard === 27 ? 'ArrowUp' : 'w')}
                    >
                        <img src={otherDefault} alt=""/>
                        <div>{keyboard === 27 ? '↑' : 'W'}</div>
                    </div>
                    <div className={styles.middle}>
                        <div className={classNames(styles.item, styles.active)}
                             // onClick={() => onKeyPress(keyboard === 27 ? 'ArrowLeft' : 'a')}
                            //pc
                             onMouseDown={() => onKeyPress(keyboard === 27 ? 'ArrowLeft' : 'a')}
                             onMouseUp={() => onKeyUp(keyboard === 27 ? 'ArrowLeft' : 'a')}
                             onMouseOut={() => onKeyUp(keyboard === 27 ? 'ArrowLeft' : 'a')}
                            //mobile
                             onTouchStart={(e) => {e.preventDefault();onKeyPress(keyboard === 27 ? 'ArrowLeft' : 'a')}}
                             onTouchEnd={() => onKeyUp(keyboard === 27 ? 'ArrowLeft' : 'a')}
                        >
                            <img src={otherDefault} alt=""/>
                            <div>{keyboard === 27 ? '←' : 'A'}</div>
                        </div>
                        <div className={classNames(styles.item, styles.active)}
                             // onClick={() => onKeyPress(keyboard === 27 ? 'ArrowRight' : 'd')}
                            //pc
                             onMouseDown={() => onKeyPress(keyboard === 27 ? 'ArrowRight' : 'd')}
                             onMouseUp={() => onKeyUp(keyboard === 27 ? 'ArrowRight' : 'd')}
                             onMouseOut={() => onKeyUp(keyboard === 27 ? 'ArrowRight' : 'd')}
                            //mobile
                             onTouchStart={(e) => {e.preventDefault();onKeyPress(keyboard === 27 ? 'ArrowRight' : 'd')}}
                             onTouchEnd={() => onKeyUp(keyboard === 27 ? 'ArrowRight' : 'd')}
                        >
                            <img src={otherDefault} alt=""/>
                            <div>{keyboard === 27 ? '→' : 'D'}</div>
                        </div>
                    </div>
                    <div className={classNames(styles.item, styles.active)}
                         // onClick={() => onKeyPress(keyboard === 27 ? 'ArrowDown' : 's')}
                        //pc
                         onMouseDown={() => onKeyPress(keyboard === 27 ? 'ArrowDown' : 's')}
                         onMouseUp={() => onKeyUp(keyboard === 27 ? 'ArrowDown' : 's')}
                         onMouseOut={() => onKeyUp(keyboard === 27 ? 'ArrowDown' : 's')}
                        //mobile
                         onTouchStart={(e) => {e.preventDefault();onKeyPress(keyboard === 27 ? 'ArrowDown' : 's')}}
                         onTouchEnd={() => onKeyUp(keyboard === 27 ? 'ArrowDown' : 's')}
                    >
                        <img src={otherDefault} alt=""/>
                        <div>{keyboard === 27 ? '↓' : 'S'}</div>
                    </div>
                </div>
                }
                {keyboard === 29 &&
                <div className={styles.gameKeyboardLessThanThree}>
                    {keyList.map(item => (
                        <div className={classNames(styles.item, styles.active)} key={item}
                             //pc
                             onMouseDown={() => onKeyPress(this.keyPress(item))}
                             onMouseUp={() => onKeyUp(this.keyPress(item))}
                             onMouseOut={() => onKeyUp(this.keyPress(item))}
                             //mobile
                             onTouchStart={(e) => {e.preventDefault();onKeyPress(this.keyPress(item))}}
                             onTouchEnd={() => onKeyUp(this.keyPress(item))}
                        >
                            <img src={otherDefault} alt=""/>
                            <div>{this.keyShow(item)}</div>
                        </div>
                    ))}
                </div>
                }
                {[21, 22, 23].indexOf(keyboard) > -1 &&
                <div className={classNames(styles.gameKeyboardMoreThanFour, {[styles.paddingTopWeb]: !isMobile})}>
                    <div className={styles.line}>
                        <div className={classNames(styles.item, {[styles.active]: keyList.indexOf('space') > -1 || keyList.indexOf('6') > -1})}
                             // onClick={() => onKeyPress(keyList.indexOf('space') > -1 ? ' ' : (keyList.indexOf('6') > -1 ? '6' : ''))}
                            //pc
                             onMouseDown={() => onKeyPress(keyList.indexOf('space') > -1 ? ' ' : (keyList.indexOf('6') > -1 ? '6' : ''))}
                             onMouseUp={() => onKeyUp(keyList.indexOf('space') > -1 ? ' ' : (keyList.indexOf('6') > -1 ? '6' : ''))}
                             onMouseOut={() => onKeyUp(keyList.indexOf('space') > -1 ? ' ' : (keyList.indexOf('6') > -1 ? '6' : ''))}
                            //mobile
                             onTouchStart={(e) => {e.preventDefault();onKeyPress(keyList.indexOf('space') > -1 ? ' ' : (keyList.indexOf('6') > -1 ? '6' : ''))}}
                             onTouchEnd={() => onKeyUp(keyList.indexOf('space') > -1 ? ' ' : (keyList.indexOf('6') > -1 ? '6' : ''))}
                        >
                            <img src={keyList.indexOf('space') > -1 || keyList.indexOf('6') > -1 ? otherDefault : otherDisabled} alt=""/>
                            <div>{keyboard === 21 || keyboard === 22 ? '空格' : (keyboard === 23 ? '6' : '')}</div>
                        </div>
                        <div className={classNames(styles.item, {[styles.active]: keyList.indexOf('0') > -1 || keyList.indexOf('c') > -1 || keyList.indexOf('5') > -1})}
                             // onClick={() => onKeyPress(keyList.indexOf('0') > -1 ? '0' : (keyList.indexOf('c') > -1 ? 'c' : (keyList.indexOf('5') > -1 ? '5' : '')))}
                            //pc
                             onMouseDown={() => onKeyPress(keyList.indexOf('0') > -1 ? '0' : (keyList.indexOf('c') > -1 ? 'c' : (keyList.indexOf('5') > -1 ? '5' : '')))}
                             onMouseUp={() => onKeyUp(keyList.indexOf('0') > -1 ? '0' : (keyList.indexOf('c') > -1 ? 'c' : (keyList.indexOf('5') > -1 ? '5' : '')))}
                             onMouseOut={() => onKeyUp(keyList.indexOf('0') > -1 ? '0' : (keyList.indexOf('c') > -1 ? 'c' : (keyList.indexOf('5') > -1 ? '5' : '')))}
                            //mobile
                             onTouchStart={(e) => {e.preventDefault();onKeyPress(keyList.indexOf('0') > -1 ? '0' : (keyList.indexOf('c') > -1 ? 'c' : (keyList.indexOf('5') > -1 ? '5' : '')))}}
                             onTouchEnd={() => onKeyUp(keyList.indexOf('0') > -1 ? '0' : (keyList.indexOf('c') > -1 ? 'c' : (keyList.indexOf('5') > -1 ? '5' : '')))}
                        >
                            <img src={keyList.indexOf('0') > -1 || keyList.indexOf('c') > -1 || keyList.indexOf('5') > -1 ? otherDefault : otherDisabled} alt=""/>
                            <div>{keyboard === 21 ? '0' : (keyboard === 22 ? 'C' : (keyboard === 23 ? '5' : ''))}</div>
                        </div>
                    </div>
                    <div className={classNames(styles.line, styles.secondLine)}>
                        <div className={classNames(styles.item, {[styles.active]: keyList.indexOf('w') > -1 || (keyList.indexOf('up arrow') > -1 && keyboard === 23)})}
                             // onClick={() => onKeyPress(keyList.indexOf('w') > -1 ? 'w' : ((keyList.indexOf('up arrow') > -1 && keyboard === 23) ? 'ArrowUp' : ''))}
                            //pc
                             onMouseDown={() => onKeyPress(keyList.indexOf('w') > -1 ? 'w' : ((keyList.indexOf('up arrow') > -1 && keyboard === 23) ? 'ArrowUp' : ''))}
                             onMouseUp={() => onKeyUp(keyList.indexOf('w') > -1 ? 'w' : ((keyList.indexOf('up arrow') > -1 && keyboard === 23) ? 'ArrowUp' : ''))}
                             onMouseOut={() => onKeyUp(keyList.indexOf('w') > -1 ? 'w' : ((keyList.indexOf('up arrow') > -1 && keyboard === 23) ? 'ArrowUp' : ''))}
                            //mobile
                             onTouchStart={(e) => {e.preventDefault();onKeyPress(keyList.indexOf('w') > -1 ? 'w' : ((keyList.indexOf('up arrow') > -1 && keyboard === 23) ? 'ArrowUp' : ''))}}
                             onTouchEnd={() => onKeyUp(keyList.indexOf('w') > -1 ? 'w' : ((keyList.indexOf('up arrow') > -1 && keyboard === 23) ? 'ArrowUp' : ''))}
                        >
                            <img src={keyList.indexOf('w') > -1 || (keyList.indexOf('up arrow') > -1 && keyboard === 23) ? otherDefault : otherDisabled} alt=""/>
                            <div>{keyboard === 21 || keyboard === 22 ? 'W' : (keyboard === 23 ? '↑' : '')}</div>
                        </div>
                        <div className={classNames(styles.item, {[styles.active]: keyList.indexOf('1') > -1 || keyList.indexOf('q') > -1 || (keyList.indexOf('up arrow') > -1 && keyboard === 21)})}
                             // onClick={() => onKeyPress(keyList.indexOf('1') > -1 ? '1' : (keyList.indexOf('q') > -1 ? 'q' : ((keyList.indexOf('up arrow') > -1 && keyboard === 21) ? 'ArrowUp' : '')))}
                            //pc
                             onMouseDown={() => onKeyPress(keyList.indexOf('1') > -1 ? '1' : (keyList.indexOf('q') > -1 ? 'q' : ((keyList.indexOf('up arrow') > -1 && keyboard === 21) ? 'ArrowUp' : '')))}
                             onMouseUp={() => onKeyUp(keyList.indexOf('1') > -1 ? '1' : (keyList.indexOf('q') > -1 ? 'q' : ((keyList.indexOf('up arrow') > -1 && keyboard === 21) ? 'ArrowUp' : '')))}
                             onMouseOut={() => onKeyUp(keyList.indexOf('1') > -1 ? '1' : (keyList.indexOf('q') > -1 ? 'q' : ((keyList.indexOf('up arrow') > -1 && keyboard === 21) ? 'ArrowUp' : '')))}
                            //mobile
                             onTouchStart={(e) => {e.preventDefault();onKeyPress(keyList.indexOf('1') > -1 ? '1' : (keyList.indexOf('q') > -1 ? 'q' : ((keyList.indexOf('up arrow') > -1 && keyboard === 21) ? 'ArrowUp' : '')))}}
                             onTouchEnd={() => onKeyUp(keyList.indexOf('1') > -1 ? '1' : (keyList.indexOf('q') > -1 ? 'q' : ((keyList.indexOf('up arrow') > -1 && keyboard === 21) ? 'ArrowUp' : '')))}
                        >
                            <img src={keyList.indexOf('1') > -1 || keyList.indexOf('q') > -1 || (keyList.indexOf('up arrow') > -1 && keyboard === 21) ? otherDefault : otherDisabled} alt=""/>
                            <div>{keyboard === 23 ? '1' : (keyboard === 22 ? 'Q' : (keyboard === 21 ? '↑' : ''))}</div>
                        </div>
                    </div>
                    <div className={styles.line}>
                        <div className={classNames(styles.item, {[styles.active]: keyList.indexOf('a') > -1 || (keyList.indexOf('left arrow') > -1 && keyboard === 23)})}
                             // onClick={() => onKeyPress(keyList.indexOf('a') > -1 ? 'a' : ((keyList.indexOf('left arrow') > -1 && keyboard === 23) ? 'ArrowLeft' : ''))}
                            //pc
                             onMouseDown={() => onKeyPress(keyList.indexOf('a') > -1 ? 'a' : ((keyList.indexOf('left arrow') > -1 && keyboard === 23) ? 'ArrowLeft' : ''))}
                             onMouseUp={() => onKeyUp(keyList.indexOf('a') > -1 ? 'a' : ((keyList.indexOf('left arrow') > -1 && keyboard === 23) ? 'ArrowLeft' : ''))}
                             onMouseOut={() => onKeyUp(keyList.indexOf('a') > -1 ? 'a' : ((keyList.indexOf('left arrow') > -1 && keyboard === 23) ? 'ArrowLeft' : ''))}
                            //mobile
                             onTouchStart={(e) => {e.preventDefault();onKeyPress(keyList.indexOf('a') > -1 ? 'a' : ((keyList.indexOf('left arrow') > -1 && keyboard === 23) ? 'ArrowLeft' : ''))}}
                             onTouchEnd={() => onKeyUp(keyList.indexOf('a') > -1 ? 'a' : ((keyList.indexOf('left arrow') > -1 && keyboard === 23) ? 'ArrowLeft' : ''))}
                        >
                            <img src={keyList.indexOf('a') > -1 || (keyList.indexOf('left arrow') > -1 && keyboard === 23) ? otherDefault : otherDisabled} alt=""/>
                            <div>{keyboard === 21 || keyboard === 22 ? 'A' : (keyboard === 23 ? '←' : '')}</div>
                        </div>
                        <div className={classNames(styles.item, {[styles.active]: keyList.indexOf('d') > -1 || (keyList.indexOf('right arrow') > -1 && keyboard === 23)})}
                             // onClick={() => onKeyPress(keyList.indexOf('d') > -1 ? 'd' : ((keyList.indexOf('right arrow') > -1 && keyboard === 23) ? 'ArrowRight' : ''))}
                            //pc
                             onMouseDown={() => onKeyPress(keyList.indexOf('d') > -1 ? 'd' : ((keyList.indexOf('right arrow') > -1 && keyboard === 23) ? 'ArrowRight' : ''))}
                             onMouseUp={() => onKeyUp(keyList.indexOf('d') > -1 ? 'd' : ((keyList.indexOf('right arrow') > -1 && keyboard === 23) ? 'ArrowRight' : ''))}
                             onMouseOut={() => onKeyUp(keyList.indexOf('d') > -1 ? 'd' : ((keyList.indexOf('right arrow') > -1 && keyboard === 23) ? 'ArrowRight' : ''))}
                            //mobile
                             onTouchStart={(e) => {e.preventDefault();onKeyPress(keyList.indexOf('d') > -1 ? 'd' : ((keyList.indexOf('right arrow') > -1 && keyboard === 23) ? 'ArrowRight' : ''))}}
                             onTouchEnd={() => onKeyUp(keyList.indexOf('d') > -1 ? 'd' : ((keyList.indexOf('right arrow') > -1 && keyboard === 23) ? 'ArrowRight' : ''))}
                        >
                            <img src={keyList.indexOf('d') > -1 || (keyList.indexOf('right arrow') > -1 && keyboard === 23) ? otherDefault : otherDisabled} alt=""/>
                            <div>{keyboard === 21 || keyboard === 22 ? 'D' : (keyboard === 23 ? '→' : '')}</div>
                        </div>
                        <div className={styles.empty}>

                        </div>
                        <div className={classNames(styles.item, {[styles.active]: keyList.indexOf('4') > -1 || keyList.indexOf('x') > -1 || (keyList.indexOf('left arrow') > -1 && keyboard === 21)})}
                             // onClick={() => onKeyPress((keyList.indexOf('left arrow') > -1 && keyboard === 21) ? 'ArrowLeft' : (keyList.indexOf('x') > -1 ? 'x' : (keyList.indexOf('4') > -1 ? '4' : '')))}
                            //pc
                             onMouseDown={() => onKeyPress((keyList.indexOf('left arrow') > -1 && keyboard === 21) ? 'ArrowLeft' : (keyList.indexOf('x') > -1 ? 'x' : (keyList.indexOf('4') > -1 ? '4' : '')))}
                             onMouseUp={() => onKeyUp((keyList.indexOf('left arrow') > -1 && keyboard === 21) ? 'ArrowLeft' : (keyList.indexOf('x') > -1 ? 'x' : (keyList.indexOf('4') > -1 ? '4' : '')))}
                             onMouseOut={() => onKeyUp((keyList.indexOf('left arrow') > -1 && keyboard === 21) ? 'ArrowLeft' : (keyList.indexOf('x') > -1 ? 'x' : (keyList.indexOf('4') > -1 ? '4' : '')))}
                            //mobile
                             onTouchStart={(e) => {e.preventDefault();onKeyPress((keyList.indexOf('left arrow') > -1 && keyboard === 21) ? 'ArrowLeft' : (keyList.indexOf('x') > -1 ? 'x' : (keyList.indexOf('4') > -1 ? '4' : '')))}}
                             onTouchEnd={() => onKeyUp((keyList.indexOf('left arrow') > -1 && keyboard === 21) ? 'ArrowLeft' : (keyList.indexOf('x') > -1 ? 'x' : (keyList.indexOf('4') > -1 ? '4' : '')))}
                        >
                            <img src={(keyList.indexOf('left arrow') > -1 && keyboard === 21) || keyList.indexOf('x') > -1 || keyList.indexOf('4') > -1 ? otherDefault : otherDisabled} alt=""/>
                            <div>{keyboard === 21 ? '←' : (keyboard === 22 ? 'X' : (keyboard === 23 ? '4' : ''))}</div>
                        </div>
                        <div className={classNames(styles.item, {[styles.active]: keyList.indexOf('2') > -1 || keyList.indexOf('e') > -1 || (keyList.indexOf('right arrow') > -1 && keyboard === 21)})}
                             // onClick={() => onKeyPress((keyList.indexOf('right arrow') > -1 && keyboard === 21) ? 'ArrowRight' : (keyList.indexOf('e') > -1 ? 'e' : (keyList.indexOf('2') > -1 ? '2' : '')))}
                            //pc
                             onMouseDown={() => onKeyPress((keyList.indexOf('right arrow') > -1 && keyboard === 21) ? 'ArrowRight' : (keyList.indexOf('e') > -1 ? 'e' : (keyList.indexOf('2') > -1 ? '2' : '')))}
                             onMouseUp={() => onKeyUp((keyList.indexOf('right arrow') > -1 && keyboard === 21) ? 'ArrowRight' : (keyList.indexOf('e') > -1 ? 'e' : (keyList.indexOf('2') > -1 ? '2' : '')))}
                             onMouseOut={() => onKeyUp((keyList.indexOf('right arrow') > -1 && keyboard === 21) ? 'ArrowRight' : (keyList.indexOf('e') > -1 ? 'e' : (keyList.indexOf('2') > -1 ? '2' : '')))}
                            //mobile
                             onTouchStart={(e) => {e.preventDefault();onKeyPress((keyList.indexOf('right arrow') > -1 && keyboard === 21) ? 'ArrowRight' : (keyList.indexOf('e') > -1 ? 'e' : (keyList.indexOf('2') > -1 ? '2' : '')))}}
                             onTouchEnd={() => onKeyUp((keyList.indexOf('right arrow') > -1 && keyboard === 21) ? 'ArrowRight' : (keyList.indexOf('e') > -1 ? 'e' : (keyList.indexOf('2') > -1 ? '2' : '')))}
                        >
                            <img src={(keyList.indexOf('right arrow') > -1 && keyboard === 21) || keyList.indexOf('e') > -1 || keyList.indexOf('2') > -1 ? otherDefault : otherDisabled} alt=""/>
                            <div>{keyboard === 21 ? '→' : (keyboard === 22 ? 'E' : (keyboard === 23 ? '2' : ''))}</div>
                        </div>
                    </div>
                    <div className={classNames(styles.line, styles.fourthLine)}>
                        <div className={classNames(styles.item, {[styles.active]: keyList.indexOf('s') > -1 || (keyList.indexOf('down arrow') > -1 && keyboard === 23)})}
                             // onClick={() => onKeyPress(keyList.indexOf('s') > -1 ? 's' : ((keyList.indexOf('down arrow') > -1 && keyboard === 23) ? 'ArrowDown' : ''))}
                            //pc
                             onMouseDown={() => onKeyPress(keyList.indexOf('s') > -1 ? 's' : ((keyList.indexOf('down arrow') > -1 && keyboard === 23) ? 'ArrowDown' : ''))}
                             onMouseUp={() => onKeyUp(keyList.indexOf('s') > -1 ? 's' : ((keyList.indexOf('down arrow') > -1 && keyboard === 23) ? 'ArrowDown' : ''))}
                             onMouseOut={() => onKeyUp(keyList.indexOf('s') > -1 ? 's' : ((keyList.indexOf('down arrow') > -1 && keyboard === 23) ? 'ArrowDown' : ''))}
                            //mobile
                             onTouchStart={(e) => {e.preventDefault();onKeyPress(keyList.indexOf('s') > -1 ? 's' : ((keyList.indexOf('down arrow') > -1 && keyboard === 23) ? 'ArrowDown' : ''))}}
                             onTouchEnd={() => onKeyUp(keyList.indexOf('s') > -1 ? 's' : ((keyList.indexOf('down arrow') > -1 && keyboard === 23) ? 'ArrowDown' : ''))}
                        >
                            <img src={keyList.indexOf('s') > -1 || (keyList.indexOf('down arrow') > -1 && keyboard === 23) ? otherDefault : otherDisabled} alt=""/>
                            <div>{keyboard === 21 || keyboard === 22 ? 'S' : (keyboard === 23 ? '↓' : '')}</div>
                        </div>
                        <div className={classNames(styles.item, {[styles.active]: keyList.indexOf('3') > -1 || keyList.indexOf('z') > -1 || (keyList.indexOf('down arrow') > -1 && keyboard === 21)})}
                             // onClick={() => onKeyPress((keyList.indexOf('down arrow') > -1 && keyboard === 21) ? 'ArrowDown' : (keyList.indexOf('z') > -1 ? 'z' : (keyList.indexOf('3') > -1 ? '3' : '')))}
                            //pc
                             onMouseDown={() => onKeyPress((keyList.indexOf('down arrow') > -1 && keyboard === 21) ? 'ArrowDown' : (keyList.indexOf('z') > -1 ? 'z' : (keyList.indexOf('3') > -1 ? '3' : '')))}
                             onMouseUp={() => onKeyUp((keyList.indexOf('down arrow') > -1 && keyboard === 21) ? 'ArrowDown' : (keyList.indexOf('z') > -1 ? 'z' : (keyList.indexOf('3') > -1 ? '3' : '')))}
                             onMouseOut={() => onKeyUp((keyList.indexOf('down arrow') > -1 && keyboard === 21) ? 'ArrowDown' : (keyList.indexOf('z') > -1 ? 'z' : (keyList.indexOf('3') > -1 ? '3' : '')))}
                            //mobile
                             onTouchStart={(e) => {e.preventDefault();onKeyPress((keyList.indexOf('down arrow') > -1 && keyboard === 21) ? 'ArrowDown' : (keyList.indexOf('z') > -1 ? 'z' : (keyList.indexOf('3') > -1 ? '3' : '')))}}
                             onTouchEnd={() => onKeyUp((keyList.indexOf('down arrow') > -1 && keyboard === 21) ? 'ArrowDown' : (keyList.indexOf('z') > -1 ? 'z' : (keyList.indexOf('3') > -1 ? '3' : '')))}
                        >
                            <img src={(keyList.indexOf('down arrow') > -1 && keyboard === 21) || keyList.indexOf('z') > -1 || keyList.indexOf('3') > -1 ? otherDefault : otherDisabled} alt=""/>
                            <div>{keyboard === 21 ? '↓' : (keyboard === 22 ? 'Z' : (keyboard === 23 ? '3' : ''))}</div>
                        </div>
                    </div>
                </div>
                }
                {/* 数字键盘 */}
                {keyboard === 30 &&
                <div className={classNames(styles.numberKeyboard, {[styles.numberKeyboardPadding]: !isMobile})} style={{paddingTop: isMobile ? '0.6rem' : ''}}>
                    <div className={classNames(styles.firstLine, styles.flex)}>
                        {['1', '2', '3'].map(item => (
                            <div className={classNames(styles.item, {[styles.active]: keyList.indexOf(item) > -1})} key={item}
                                 // onClick={() => onKeyPress(item)}
                                //pc
                                 onMouseDown={() => onKeyPress(item)}
                                 onMouseUp={() => onKeyUp(item)}
                                 onMouseOut={() => onKeyUp(item)}
                                //mobile
                                 onTouchStart={(e) => {e.preventDefault();onKeyPress(item)}}
                                 onTouchEnd={() => onKeyUp(item)}
                            >
                                <img src={keyList.indexOf(item) > -1 ? otherDefault : otherDisabled} alt=""/>
                                <div>{item}</div>
                            </div>
                        ))}
                    </div>
                    <div className={classNames(styles.secondLine, styles.flex)}>
                        {['4', '5', '6'].map(item => (
                            <div className={classNames(styles.item, {[styles.active]: keyList.indexOf(item) > -1})} key={item}
                                 // onClick={() => onKeyPress(item)}
                                //pc
                                 onMouseDown={() => onKeyPress(item)}
                                 onMouseUp={() => onKeyUp(item)}
                                 onMouseOut={() => onKeyUp(item)}
                                //mobile
                                 onTouchStart={(e) => {e.preventDefault();onKeyPress(item)}}
                                 onTouchEnd={() => onKeyUp(item)}
                            >
                                <img src={keyList.indexOf(item) > -1 ? otherDefault : otherDisabled} alt=""/>
                                <div>{item}</div>
                            </div>
                        ))}
                    </div>
                    <div className={classNames(styles.flex)}>
                        {['7', '8', '9'].map(item => (
                            <div className={classNames(styles.item, {[styles.active]: keyList.indexOf(item) > -1})} key={item}
                                 // onClick={() => onKeyPress(item)}
                                //pc
                                 onMouseDown={() => onKeyPress(item)}
                                 onMouseUp={() => onKeyUp(item)}
                                 onMouseOut={() => onKeyUp(item)}
                                //mobile
                                 onTouchStart={(e) => {e.preventDefault();onKeyPress(item)}}
                                 onTouchEnd={() => onKeyUp(item)}
                            >
                                <img src={keyList.indexOf(item) > -1 ? otherDefault : otherDisabled} alt=""/>
                                <div>{item}</div>
                            </div>
                        ))}
                    </div>
                    <div className={classNames(styles.lastLine, styles.flex)}>
                        {['0'].map(item => (
                            <div className={classNames(styles.item, {[styles.active]: keyList.indexOf(item) > -1})} key={item}
                                 // onClick={() => onKeyPress(item)}
                                //pc
                                 onMouseDown={() => onKeyPress(item)}
                                 onMouseUp={() => onKeyUp(item)}
                                 onMouseOut={() => onKeyUp(item)}
                                //mobile
                                 onTouchStart={(e) => {e.preventDefault();onKeyPress(item)}}
                                 onTouchEnd={() => onKeyUp(item)}
                            >
                                <img src={keyList.indexOf(item) > -1 ? otherDefault : otherDisabled} alt=""/>
                                <div>{item}</div>
                            </div>
                        ))}
                    </div>
                </div>
                }
                {keyboard === -1 &&
                <div className={styles.noSupportKeyboard}>该作品用到{noSupportKey.join('，')}键，{isMobile ? '请到电脑端体验' : '请使用实体键盘体验'}。</div>
                }
                {keyboard === 0 &&
                    <div>
                        <div className={styles.mideLogo}>
                            <img src={mide} alt=""/>
                        </div>
                        <div className={styles.userName}>{userName}</div>
                    </div>
                }
            </div>
        );
    }
}

KeyboardComponent.propTypes = {
    keyboard: PropTypes.number,
    keyList: PropTypes.array,
    onKeyPress: PropTypes.func,
    onKeyUp: PropTypes.func,
    setKeyboardType: PropTypes.func,
    userName: PropTypes.string
};

const mapStateToProps = state => ({

});

const mapDispatchToProps = dispatch => ({
    setKeyboardType: type => dispatch(setKeyboardType(type))
});

export default connect(mapStateToProps, mapDispatchToProps)(KeyboardComponent);
